import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderListingContext } from "../context/OrderListingContext";
import { isDeliveryFolderMissingWhenRequired, OrderListingItem } from "../OrderListingItem";

export type ApproveOrderDeliveryListingDialogProps = {
    item: OrderListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const ApproveOrderDeliveryListingDialog: React.VFC<ApproveOrderDeliveryListingDialogProps> = ({
    item,
    isOpen,
    onClose
}: ApproveOrderDeliveryListingDialogProps) => {
    const { approveOrderDelivery } = useOrdersModuleApi();

    const { approveDelivery } = useContext(OrderListingContext);

    const { success } = useNotifications();

    const approve = async () => {
        await approveOrderDelivery({ orderId: item.id });

        approveDelivery(item.id);

        success("Delivery approved");

        onClose();
    };

    return (
        <ConfirmDialog
            title="Approve Order Delivery"
            text="Are you sure you want to deliver this order?"
            hidden={!isOpen}
            confirm={{ onClick: approve }}
            cancel={{ onClick: onClose }}
        />
    );
};

export const isOrderApprovable = (item: OrderListingItem): boolean => {
    return (
        (item.status === OrderStatus.Encoded ||
            item.status === OrderStatus.DeliveryFailed ||
            item.status === OrderStatus.DeliveryError) &&
        !isDeliveryFolderMissingWhenRequired(item)
    );
};
